'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SemiprivateToggle = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseRadioButton = require('@bibliocommons/base-radio-button');

var _baseRadioButton2 = _interopRequireDefault(_baseRadioButton);

require('../styles/SemiprivateToggle.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  list: _react2.default.PropTypes.object.isRequired,
  handlePropertyChange: _react2.default.PropTypes.func.isRequired,

  intl: _react2.default.PropTypes.object.isRequired
};

var SemiprivateToggle = exports.SemiprivateToggle = function (_BcReactComponent) {
  _inherits(SemiprivateToggle, _BcReactComponent);

  function SemiprivateToggle(props) {
    _classCallCheck(this, SemiprivateToggle);

    var _this = _possibleConstructorReturn(this, (SemiprivateToggle.__proto__ || Object.getPrototypeOf(SemiprivateToggle)).call(this, props));

    _this.bindAll('handleChange');
    return _this;
  }

  _createClass(SemiprivateToggle, [{
    key: 'handleChange',
    value: function handleChange(value) {
      this.props.handlePropertyChange({
        listType: value === 'semiprivate' ? 'personal_recommendation' : 'other'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          list = _props.list,
          intl = _props.intl;


      return _react2.default.createElement(
        'div',
        { className: 'cp-user-list-semiprivate-toggle' },
        _react2.default.createElement(
          'div',
          { className: 'property-name' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_visibility' }),
          ':'
        ),
        _react2.default.createElement(
          'fieldset',
          { className: 'radio-buttons' },
          _react2.default.createElement(
            'legend',
            { className: 'sr-only' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_visibility_options' })
          ),
          _react2.default.createElement(_baseRadioButton2.default, {
            id: 'user-list-semiprivate-toggle-public',
            name: 'semiprivate',
            value: 'public',
            label: intl.formatMessage({ id: 'user_list_public' }),
            description: intl.formatMessage({ id: 'user_list_public_description' }),
            checked: list.listType !== 'personal_recommendation',
            handleChange: this.handleChange }),
          _react2.default.createElement(_baseRadioButton2.default, {
            id: 'user-list-semiprivate-toggle-semiprivate',
            name: 'semiprivate',
            value: 'semiprivate',
            label: intl.formatMessage({ id: 'user_list_private_recommendation' }),
            description: intl.formatMessage({ id: 'user_list_private_recommendation_description' }),
            checked: list.listType === 'personal_recommendation',
            handleChange: this.handleChange })
        )
      );
    }
  }]);

  return SemiprivateToggle;
}(_baseBcReactComponent2.default);

SemiprivateToggle.propTypes = propTypes;

exports.default = (0, _reactIntl.injectIntl)(SemiprivateToggle);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/semi-private-toggle/components/SemiprivateToggle.component.js
// module id = 1338
// module chunks = 0